export default __webpack_public_path__ + "static/media/coresanscr35-webfont.acda3f36.woff2";